import { Injectable } from '@angular/core';
import {CanActivate,ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AutorizacionService } from './autorizacion.service';
// observable
import { Observable } from 'rxjs/Observable';

@Injectable()
export class MyGuardService implements CanActivate{
  // variable miembro
  loggedIn=false;
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | Observable<boolean> | Promise<boolean> {
    //throw new Error("Method not implemented.");
    return this.loggedIn;
  }

  // operaciones al crear instancia de clase
  constructor( private autorizacionService: AutorizacionService) { 
    //
    this.autorizacionService.isLogged()
      .subscribe((result)=>{
        if(result && result.uid){
          this.loggedIn=true;
        }else{
          this.loggedIn=false;
        }
      }, (error)=>{
        this.loggedIn=false;
      })
  }

}



// WEBPACK FOOTER //
// C:/Users/USUARIO/Documents/Platzi/cursos__2017/Angular_4_PROFESIONAL/proyectos/platzisquare2/src/app/services/my-guard.service.ts